class Ladder {

	constructor() {
		this.logging = IS_LOCALHOST;
		var ladder = this;
	}

	log(message, fThePolice) {
		if(!console || !console.log) {
			return;
		}
		if(fThePolice || ladder.logging) {
			if(console.trace) {
				console.trace(message);
			}
		}
	}
}

var ladder = new Ladder();

class LadderLocalStorage {

	constructor() {
		if(!localStorage) {
			window.localStorage = {};
			localStorage.setItem = function() {
			};
			localStorage.getItem = function() {
			};
			localStorage.removeItem = function() {
			};
		}
	}

	setItem(key, object) {
		return localStorage.setItem(key, JSON.stringify(object));
	}

	getItem(key, defaultValue) {
		const value = localStorage.getItem(key);
		if(value === null) {
			return defaultValue;
		}
		try {
			return JSON.parse(localStorage.getItem(key));
		} catch(error) {
			console.log('got', localStorage.getItem(key));
			console.error(error);
			console.log(key, defaultValue);
			return defaultValue;
		}
	}

	incrementKey(key) {
		if(!localStorage.getItem(key)) {
			localStorage.setItem(key, 0);
		}
		localStorage.setItem(key,
			parseInt(localStorage.getItem(key)) + 1
		);
		return this.getIntValue(key);
	}

	getIntValue(key) {
		return parseInt(localStorage.getItem(key));
	}

	removeItem(key) {
		return localStorage.removeItem(key);
	}

}

const ladderLocalStorage = new LadderLocalStorage();
export { Ladder, ladder, ladderLocalStorage };
